import React from "react"
import badge from "badges/advanced-thinking-skills.svg"
import { BadgeImage } from "backpack/badges/styled"

const AdvanceThinkingSkills = props => <BadgeImage src={badge} {...props} />

export default AdvanceThinkingSkills
